var map = {
	"./clause_confirmation101.png": "bTaC",
	"./clause_confirmation102.png": "JMqW",
	"./clause_confirmation111.png": "oPCk",
	"./clause_confirmation112.png": "g7a9",
	"./clause_confirmation132.png": "F++4",
	"./clause_confirmation133.png": "tS4N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pWqh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book ^\.\/clause_confirmation.*\.png$
// module id = pWqh
// module chunks = 1